import { TextInput } from '@tremor/react';
import { ChangeEventHandler, ReactElement, useState } from 'react';
import { DEFAULT_TEXTFIELD_TYPE } from '../commons/constants/constants';
import { addCypressSelector } from '../commons/utils/utils';
interface EditableTextFieldProps {
  label: string;
  id: string;
  value: string;
  changeEvent: ChangeEventHandler<HTMLInputElement>;
  error?: string;
  placeholder?: string;
  description?: string;
  customWidth?: string;
  isDisabled?: boolean;
  reserveErrorSpace?: boolean;
  customLabelStyle?: string;
  maxLength?: number;
  pattern?: string;
  required?: boolean;
  type?: TextFieldType;
  cypressAttribute?: string;
}
const EditableTextField = ({
  label,
  id,
  value,
  changeEvent,
  error,
  description,
  customWidth,
  isDisabled = false,
  placeholder,
  reserveErrorSpace = false,
  customLabelStyle = '',
  maxLength,
  pattern,
  required = false,
  type = DEFAULT_TEXTFIELD_TYPE,
  cypressAttribute
}: EditableTextFieldProps): ReactElement => {
  const [showError, setShowError] = useState(false);
  const handleMouseEnter = (): void => {
    if (error) setShowError(true);
  };
  const handleMouseLeave = (): void => {
    setShowError(false);
  };
  return <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={`input-wrapper ${customWidth}`} data-sentry-component="EditableTextField" data-sentry-source-file="EditableTextField.tsx">
      <label htmlFor={id} className={customLabelStyle}>
        {label}
      </label>
      {description && <p className='text-[#6B7280] mb-1 text-xs mt-[.75em]'>{description}</p>}
      <TextInput error={error ? true : false} errorMessage={showError && !reserveErrorSpace ? error : ''} id={id} value={value} onChange={changeEvent} placeholder={placeholder} disabled={isDisabled} maxLength={maxLength} pattern={pattern} required={required} type={type} {...cypressAttribute ? addCypressSelector(cypressAttribute) : {}} data-sentry-element="TextInput" data-sentry-source-file="EditableTextField.tsx" />
      {reserveErrorSpace && <div className='min-h-[1.25rem] text-red-500 text-sm mt-1'>
          {showError ? error : ''}
        </div>}
    </div>;
};
export default EditableTextField;